import { searchinput, searchresultsflex, searchresults, leftdata, rightdata, menubutton, spacer, searchopen, searchbar, scrollToId, SetUrl } from "./timeline.js";

function createSearchResult(item, side) {
  const year = (item.year + "").replace("-", "Kr.e.");
  const row = document.createElement("div");
  row.classList.add("row", "flex-nowrap", "g-0", "gap-1", "px-1", "py-1", "align-items-center", "search-result");
  if (side == "left") {
    row.classList.add("flex-row-reverse");
  }
  row.addEventListener("click", () => {
    SetUrl({ year: item.year });
    scrollToId(item.year);
    closeSearchbar();
  });
  const cucc =
    /* HTML */
    `
      <div class="col-auto p-0">
        <div class="card p-0 bg-primary">
          <div class="card-body mini-date">
            <div class="date m-0 text-white opacity-75">${year}</div>
          </div>
        </div>
      </div>
      <div class="col d-flex p-0 ${side == "left" ? "justify-content-end" : ""} overflow-hidden">
        <div class="card p-0 search-result-title">
          <div class="card-body p-0">
            <div class="mini-date-title text-nowrap mx-1 overflow-hidden">${item.title}</div>
          </div>
        </div>
      </div>
    `;
  row.insertAdjacentHTML("beforeend", cucc);
  searchresultsflex.appendChild(row);
}

export function search() {
  let v = searchinput.value;
  searchresultsflex.innerHTML = "";
  if (v) {
    v = v.replace("Kr.e. ", "-");
    v = v.replace("Kr.e.", "-");
    leftdata.forEach((item) => {
      if (item.title.includes(v) || (item.year + "").includes(v)) {
        createSearchResult(item, "left");
      }
    });
    rightdata.forEach((item) => {
      if (item.title.includes(v) || (item.year + "").includes(v)) {
        createSearchResult(item, "right");
      }
    });
  }
  if (searchresultsflex.children.length > 0) {
    searchresults.classList.remove("d-none");
  } else {
    searchresults.classList.add("d-none");
  }
}

export function openSearchbar() {
  searchbar.classList.remove("d-none");
  searchinput.classList.remove("d-none");
  searchinput.focus();
  searchopen.classList.add("d-none");
  menubutton.classList.add("d-none");
  document.querySelectorAll(".select-wrapper").forEach((el) => {
    el.classList.add("d-none");
  });
  spacer.classList.add("d-none");
  if (searchinput.value !== "" && searchresultsflex.children.length > 0) {
    searchresults.classList.remove("d-none");
  }
}
export function closeSearchbar() {
  searchbar.classList.add("d-none");
  searchinput.classList.add("d-none");
  searchresults.classList.add("d-none");
  searchopen.classList.remove("d-none");
  menubutton.classList.remove("d-none");
  document.querySelectorAll(".select-wrapper").forEach((el) => {
    el.classList.remove("d-none");
  });
  spacer.classList.remove("d-none");
}
